import React from "react";

interface EventBadgesProps {
  ceremony?: boolean;
  luncheon?: boolean;
  reception?: boolean;
  plusOne?: boolean;
  plusOneName?: string;
}

const EventBadges: React.FC<EventBadgesProps> = ({
  ceremony,
  luncheon,
  reception,
  plusOne,
  plusOneName,
}) => {
  return (
    <div className="event-badges">
      {ceremony && <span className="event-badge ceremony">Ceremony</span>}
      {luncheon && <span className="event-badge ceremony">Luncheon</span>}
      {reception && <span className="event-badge reception">Reception</span>}
      {plusOne && (
        <span className="event-badge plus-one">
          {plusOneName ? `+1 (${plusOneName})` : "+1 Invited"}
        </span>
      )}
    </div>
  );
};

export default EventBadges;
